import { useEffect, useState } from "react";
import axiosInstance from "../utils/axiosInstance";
import "./css/VisitorCounter.css";

const VisitorCounter = () => {
  const [dailyCount, setDailyCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    const fetchDailyVisitor = async () => {
      try {
        const res = await axiosInstance.get("/api/daily-visitor");
        setDailyCount(res.data.dailyVisitorCount);
      } catch (err) {
        console.error("Error fetching daily count:", err);
      }
    };

    const fetchTotalVisitor = async () => {
      try {
        const res = await axiosInstance.get("/api/total-visitor");
        setTotalCount(res.data.totalVisitorCount);
      } catch (err) {
        console.error("Error fetching total count:", err);
      }
    };

    fetchDailyVisitor();
    fetchTotalVisitor();
  }, []);

  return (
    <div className="visitor-counter">
      <h1>Visitor Statistics</h1>
      <div className="visitor-stats">
        <div className="stat-card">
          <h2>Today's Visitors</h2>
          <p className="count">{dailyCount}</p>
        </div>
        <div className="stat-card">
          <h2>Total Visitors</h2>
          <p className="count">{totalCount}</p>
        </div>
      </div>
    </div>
  );
};

export default VisitorCounter;
